// Central Insights registry mapping — which published articles appear on
// which service/industry page. Single source of truth: every slug listed
// here MUST exist in insights.js (enforced by articlesFor() filtering).
import { INSIGHTS } from "./insights";

export const SERVICE_INSIGHTS = {
  "sales-transformation": [
    "why-distributor-network-underperforming",
    "how-to-diagnose-sales-productivity",
    "when-to-hire-sales-transformation-consultant",
  ],
  "channel-route-to-market": [
    "why-distributor-network-underperforming",
    "choosing-route-to-market-strategy",
    "why-channel-partners-dont-push-your-brand",
  ],
  "go-to-market-market-entry": [
    "framework-for-evaluating-market-entry",
    "why-product-launches-underperform",
    "choosing-route-to-market-strategy",
  ],
  "pricing-revenue-management": [
    "discount-not-deal",
    "how-to-identify-pricing-leakage",
    "why-growth-not-translating-into-profit",
  ],
  "marketing-strategy-integrated-communications": [
    "why-marketing-activity-isnt-producing-demand",
    "marketing-budget-question-every-ceo",
    "brand-or-performance-false-choice",
  ],
  "performance-marketing-paid-media": [
    "why-d2c-acquisition-costs-keep-rising",
    "how-to-evaluate-performance-marketing-agency",
    "roas-is-not-profit",
  ],
  "ecommerce-marketplace-growth": [
    "roas-is-not-profit",
    "why-marketplace-revenue-grows-but-profit-doesnt",
    "the-marketplace-flywheel",
  ],
  "amazon-marketplace-growth": [
    "why-marketplace-revenue-grows-but-profit-doesnt",
    "the-marketplace-flywheel",
    "what-your-amazon-acos-is-telling-you",
  ],
  "d2c-performance-marketing": [
    "why-d2c-acquisition-costs-keep-rising",
    "roas-is-not-profit",
    "brand-or-performance-false-choice",
  ],
  "d2c-cro-digital-experience": [
    "why-d2c-acquisition-costs-keep-rising",
    "roas-is-not-profit",
    "why-marketplace-revenue-grows-but-profit-doesnt",
  ],
  "crm-retention-loyalty": [
    "why-d2c-acquisition-costs-keep-rising",
    "roas-is-not-profit",
    "why-marketplace-revenue-grows-but-profit-doesnt",
  ],
  "brand-strategy-positioning": [
    "why-buyers-cant-tell-you-apart",
    "positioning-is-a-choice-not-a-tagline",
    "next-market-leader-different-problem",
  ],
  "growth-strategy": [
    "growth-not-scaling",
    "market-leaders-expired-assumptions",
    "next-market-leader-different-problem",
  ],
  "commercial-excellence-operating-model": [
    "growth-not-scaling",
    "how-to-diagnose-sales-productivity",
    "why-growth-not-translating-into-profit",
  ],
  "product-portfolio-strategy": [
    "growth-not-scaling",
    "why-product-launches-underperform",
    "why-growth-not-translating-into-profit",
  ],
  "market-opportunity-sizing": [
    "framework-for-evaluating-market-entry",
    "next-market-leader-different-problem",
    "research-that-informs-decisions",
  ],
  "customer-buyer-insights": [
    "research-that-informs-decisions",
    "market-leaders-expired-assumptions",
    "next-market-leader-different-problem",
  ],
  "segmentation-targeting": [
    "research-that-informs-decisions",
    "framework-for-evaluating-market-entry",
    "next-market-leader-different-problem",
  ],
  "competitive-intelligence": [
    "market-leaders-expired-assumptions",
    "next-market-leader-different-problem",
    "why-buyers-cant-tell-you-apart",
  ],
  "customer-decision-journey-intelligence": [
    "research-that-informs-decisions",
    "why-marketing-activity-isnt-producing-demand",
    "why-buyers-cant-tell-you-apart",
  ],
  "trends-foresight-growth-opportunities": [
    "next-market-leader-different-problem",
    "market-leaders-expired-assumptions",
    "growth-not-scaling",
  ],
  "brand-architecture-portfolio": [
    "positioning-is-a-choice-not-a-tagline",
    "growth-not-scaling",
    "why-buyers-cant-tell-you-apart",
  ],
  "brand-identity-design-systems": [
    "why-buyers-cant-tell-you-apart",
    "positioning-is-a-choice-not-a-tagline",
    "brand-or-performance-false-choice",
  ],
  "advertising-content-creative": [
    "why-marketing-activity-isnt-producing-demand",
    "brand-or-performance-false-choice",
    "marketing-budget-question-every-ceo",
  ],
  "public-relations-reputation": [
    "positioning-is-a-choice-not-a-tagline",
    "marketing-budget-question-every-ceo",
    "why-marketing-activity-isnt-producing-demand",
  ],
  "seo-content-ai-search": [
    "brand-or-performance-false-choice",
    "why-marketing-activity-isnt-producing-demand",
    "marketing-budget-question-every-ceo",
  ],
  "social-influencer-creator-marketing": [
    "brand-or-performance-false-choice",
    "why-marketing-activity-isnt-producing-demand",
    "why-d2c-acquisition-costs-keep-rising",
  ],
};

export const PRACTICE_INSIGHTS = {
  "market-customer-intelligence": [
    "research-that-informs-decisions",
    "why-buyers-cant-tell-you-apart",
    "framework-for-evaluating-market-entry",
  ],
  "digital-commerce": [
    "roas-is-not-profit",
    "why-d2c-acquisition-costs-keep-rising",
    "how-to-evaluate-performance-marketing-agency",
  ],
};

export const INDUSTRY_INSIGHTS = {
  "retail-d2c-ecommerce": [
    "why-d2c-acquisition-costs-keep-rising",
    "roas-is-not-profit",
    "why-marketplace-revenue-grows-but-profit-doesnt",
  ],
  "fmcg-consumer-products": [
    "why-distributor-network-underperforming",
    "choosing-route-to-market-strategy",
    "why-channel-partners-dont-push-your-brand",
  ],
  "consumer-durables-electronics-appliances": [
    "why-distributor-network-underperforming",
    "growth-not-scaling",
    "why-growth-not-translating-into-profit",
  ],
  "manufacturing-b2b": [
    "growth-not-scaling",
    "why-growth-not-translating-into-profit",
    "market-leaders-expired-assumptions",
  ],
  "professional-services": [
    "why-marketing-activity-isnt-producing-demand",
    "positioning-is-a-choice-not-a-tagline",
    "marketing-budget-question-every-ceo",
  ],
  "education-edtech": [
    "why-d2c-acquisition-costs-keep-rising",
    "marketing-budget-question-every-ceo",
    "framework-for-evaluating-market-entry",
  ],
  "real-estate": [
    "why-marketing-activity-isnt-producing-demand",
    "positioning-is-a-choice-not-a-tagline",
    "marketing-budget-question-every-ceo",
  ],
  "media-entertainment": [
    "why-marketing-activity-isnt-producing-demand",
    "brand-or-performance-false-choice",
    "marketing-budget-question-every-ceo",
  ],
};

// Resolve slugs → published articles, silently dropping any that don't exist
// (centralised guard against broken Related Insights links).
export function articlesFor(slugs = []) {
  return slugs.map((s) => INSIGHTS.find((a) => a.slug === s)).filter(Boolean);
}
